import { select, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { getLocation } from 'domain/router/RouterModel';

export function* reloadPage() {
  const { pathname, search } = yield select(getLocation);
  yield put(push(pathname+search));
}
